export default "__VITE_ASSET__f95b059f__"